import React, { useState } from 'react';
import PropTypes from 'prop-types';
import c from 'classnames';
import { Tooltip } from '@mui/material';

import './_errorForm.scss';

const ErrorForm = ({ message = '', tooltip }) => {
  const errorFormClass = c('error-form', { tooltip });
  const [tooltipOpen, setTooltipOpen] = useState(false);

  const openTooltip = () => setTooltipOpen(true);
  const closeTooltip = () => setTooltipOpen(false);
  const toggleTooltip = () => setTooltipOpen(!tooltipOpen);

  return tooltip ? (
    <Tooltip open={tooltipOpen} title={message} onOpen={openTooltip} onClose={closeTooltip} onClick={toggleTooltip} >
      <span className={errorFormClass}>{message}</span>
    </Tooltip>
  ) : (
    <span className={errorFormClass}>{message}</span>
  );
};

ErrorForm.propTypes = {
  message: PropTypes.string,
  tooltip: PropTypes.bool
};

export default ErrorForm;
